"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotebookStatus = void 0;
/**
 * Status for both the CodeCapsuleReport and the notebooks ran by that CodeCapsule
 */
exports.NotebookStatus = {
    IN_PROGRESS: 'in_progress',
    SUCCESS: 'success',
    FAILURE: 'failure',
};
//# sourceMappingURL=codeCapsule.js.map